import React from 'react';
import './App.css';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { AnimatePresence } from 'framer-motion';
import Header from './Layout/Header';
import Home from './Pages/Home';
import Service from './Pages/Service';
import Footer from './Layout/Footer';
import ScrollToTop from './Layout/SrollTop';
import About from './Pages/About';
import Contact from './Pages/Contact';
import Imprint from './Pages/Imprint';
import CookiePolicy from './Pages/CookiePolicy';
import CookieBanner from './Layout/CookieBanner';
import Privacy from './Pages/Privacy';
import Layout from './Layout/Layout';
import DateButton from './Components/DateButton';

function App() {
  return (
<Router>
  <ScrollToTop />
  {/* <DateButton/> */}
  <Layout>
    <AnimatePresence mode="wait">
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/service" element={<Service />} /> 
        <Route path="/ueber-uns" element={<About />} />
        <Route path="/leistungen" element={<Service />} /> 
        <Route path="/kontakt" element={<Contact />} />
        <Route path="/imprint" element={<Imprint />} />
        <Route path="/cookies" element={<CookiePolicy />} />
        <Route path="/privacy" element={<Privacy />} />
      </Routes>
    </AnimatePresence>
  </Layout>
</Router>
  );
}

export default App;
